;(function () {
	const rapooMenuTabsSetup = () => {
		const header = document.querySelector('.shopify-section-header');
		const menuTabs = header.querySelectorAll('.rapoo-menu-tabs');


		menuTabs.forEach((menuTab) => {
			//每个menuTabs自己处理自己的状态
			
			let activeTab = '';
			let activeStore = '';

			// 获取每个storeTab
			const storeTabs = menuTab.querySelectorAll('.store-tabs .store-tabs-item');

			//获取每个tabitem
			const tabItems = menuTab.querySelectorAll('.menu-tabs-item');
			//获取每个tab-content
			const tabContents = menuTab.querySelector('.menu-tab-content');
			
			//先获取初始化的那个tabitem 找到那个active的tabitem
			const initActive =menuTab.querySelector('.menu-tabs-item.active');
			if(initActive){
				activeTab = initActive.getAttribute('data-tab');
			}

			const initActiveStoreTab = menuTab.querySelector('.store-tabs .store-tabs-item.active');
			if(initActiveStoreTab){
				activeStore = initActiveStoreTab.getAttribute('data-store');
			}


			//显示某个tab
			const showTab = (tab) => {
				//先隐藏所有的tab
				tabItems.forEach((tabItem) => {
					tabItem.classList.remove('active');
				})
				//显示当前的tab
				tab.classList.add('active');
			}

			//显示tab-content
			const showTabContent = () => {
				tabContents.querySelectorAll('.product-list').forEach((tabContent) => {
					tabContent.classList.remove('active');
				})
				const willActiveEle = tabContents.querySelector(`.product-list[data-tab="${activeTab}"]`);
				willActiveEle.classList.add('active');
			}

			const changeStoreTab = (store) => {
				//给每个tabitem添加active类名
				storeTabs.forEach((storeTab) => {
					storeTab.classList.remove('active');
				})
				store.classList.add('active');
			}

			const changeStoreTabContent = () => {
				// 找到对应的menuTab
				const targetContent = menuTab.querySelector(`.menu-tabs-content[data-store='${activeStore}']`);
				
				// 去掉所有的active类名
				menuTab.querySelectorAll('.menu-tabs-content').forEach((tabItem) => {
					tabItem.classList.remove('active');
				})
				targetContent.classList.add('active');

				//并且找到第一个active的tab
				let targetActiveTab = targetContent.querySelector('.menu-tabs-item.active');
				//如果没有active的tabitem 就默认显示第一个
				if(!targetActiveTab){
					targetActiveTab = targetContent.querySelector('.menu-tabs-item');
				}

				// 获取tabid
				const tabId = targetActiveTab.getAttribute('data-tab');
				activeTab = tabId;
				// 显示tab-content
				showTabContent();
				// 显示tab
				showTab(targetActiveTab);
			}

			storeTabs.forEach((storeTab) => {
				storeTab.addEventListener('click', (e) => {
					activeStore = storeTab.getAttribute('data-store');
					changeStoreTab(storeTab);
					changeStoreTabContent();
				})
			});

			//给每个tabitem设置mouseenter事件
			tabItems.forEach((tabItem) => {
				tabItem.addEventListener('mouseenter', (e) => {
					activeTab = tabItem.getAttribute('data-tab');
					//给每个tabitem添加active类名
					showTab(tabItem);
					showTabContent();
				})
			})

		})

		// 移动端

		const mobileStoreTabs = header.querySelector('.mobile-store-tabs');
		const mobileTabContainer = header.querySelectorAll('.rapoo-menu-tab-mobile');

		if(mobileStoreTabs){
			mobileStoreTabs.querySelectorAll('.mobile-store-tabs-item').forEach((mobileStoreTab) => {
				mobileStoreTab.addEventListener('click', (e) => {
					e.preventDefault();
					mobileStoreTabs.querySelectorAll('.mobile-store-tabs-item').forEach((item) => {
						item.classList.remove('active');
					})
					mobileStoreTab.classList.add('active');

					const activeStoreTab = mobileStoreTab.getAttribute('data-store');
					const allContent = header.querySelectorAll('.mobile-menu-tabs .mobile-menu-tabs-content');
					allContent.forEach((content) => {
						const contentStoreTab = content.getAttribute('data-tab');
						if (contentStoreTab === ''){
							return;
						}
						if(contentStoreTab === activeStoreTab){
							content.classList.toggle('active', true);
						}else {
							content.classList.remove('active');
						}
					})

					// 切换每个mobile-menu-tabs-content

				})
			})
		}



		mobileTabContainer.forEach((container) => {
			const mobileTabs = container.querySelectorAll('.menu-tabs-item');
			mobileTabs.forEach((mobileTab) => {
				mobileTab.querySelector('.menu-tabs-toggle').addEventListener('click', (e) => {
					e.preventDefault();
					e.target.classList.toggle('active');
					const content = mobileTab.querySelector('.mobile-menu-tabs-item-content');
					const isOpen = content.getAttribute('data-open');
					const isOpenBool = isOpen === 'true';
					content.setAttribute('data-open', !isOpenBool);
				})
			})
		})

		// 初始化 打开第一个tab
		mobileTabContainer.forEach((container) => {
			container.querySelector('.menu-tabs-item')?.querySelector('.menu-tabs-toggle').click();
		})
		
	
	}

	document.addEventListener('shopify:section:load', rapooMenuTabsSetup)
	document.addEventListener('shopify:section:unload', rapooMenuTabsSetup)
	document.addEventListener('shopify:section:reorder', rapooMenuTabsSetup)

	rapooMenuTabsSetup();
})()
